import dayjs from 'dayjs';

import type { LANGUAGES } from '../interfaces';

export interface Translatable {
  translations?: Translations;
}

export interface Translations {
  [key: string]: Translation;
}

export interface Translation {
  [key: string]: string;
}

export type Translated<T extends Translatable> = T & { [key in keyof T['translations']]: string };

export const getLanguage = (): LANGUAGES => {
  const locale = dayjs.locale();
  return locale.toUpperCase() as LANGUAGES;
};

/**
 * Hydrates the a Translatable entity with the translations for that specific language
 *
 * @param {Object} obj - Translation object
 * @param {string} ln - String language
 * @return {Translated}
 */
export const translateEntity = <T extends Translatable = unknown>(
  obj: T,
  ln: LANGUAGES = getLanguage(),
): Translated<T> => {
  if (!obj) return obj as Translated<T>;

  const result = { ...obj };
  if (result?.translations) {
    for (const key in result.translations) {
      if (result.translations[key][ln]) {
        result[key] = result.translations[key][ln];
      } else if (result.translations[key].EN) {
        result[key] = result.translations[key].EN;
      }
    }
  }
  return result as Translated<T>;
};
